<template>
  <div class="register-container">
    <div class="bg"></div>
    <div class="register-wrap">
      <div class="title">
        <h1>{{schoolName}}</h1>
        <img src="https://img1.wxzxzj.com/vuedb1a3831644c62402b0cc088a9cfbe6ac.png">
      </div>
      <div class="content">
        <template v-if="!isRegister">
          <div class="input-wrap">
            <el-row>
              <el-col :span="16">
                <input type="tel"
                       placeholder="请输入手机号"
                       v-model="phone">
              </el-col>
              <el-col :span="8">
                <div class="sms-wrap" :class="{ counting: !isCountdown }" @click="sendCaptcha">
                  <span v-if="isCountdown">{{seconds}}s</span>
                  <span v-else>获取验证码</span>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="input-wrap">
            <input type="text"
                   maxlength="6"
                   placeholder="请输入验证码"
                   v-model="code">
          </div>
          <div class="input-wrap">
            <input type="text"
                   maxlength="20"
                   placeholder="请输入学生姓名"
                   v-model="studentName">
          </div>
          <div class="input-wrap">
            <input type="password"
                   maxlength="20"
                   placeholder="请输设置密码"
                   v-model="password">
          </div>
        </template>
        <template v-else>
          <div class="card">
            <img width="120" src="https://img1.wxzxzj.com/vued14ba0675751e6bd59e7398059d3570c1.png">
            <h1>{{studentName}}</h1>
            <p>报名成功</p>
          </div>
        </template>
        <button @click="submit" v-if="!isRegister">确认报名</button>
        <br />
        <p class="tip" v-if="!isRegister">此页面开通学生账号，联系老师激活课程卡。</p>
        <p class="tip" v-else>
          在学习中心输入姓名及密码即可登录学习系统开始学习
          <br /> 如需激活学习课程
          <br /> 请联系学习中心老师进行开卡操作
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Col, Loading, Row } from 'element-ui';
import utils from '@/services/utils';
import api from '@/api/graphql/account/index';

const REG_PHONE = /^1[\d]{10}$/;
const REG_PASSWORD = /^[0-9A-Za-z]{6,20}$/;
const REG_ST_NAME = /^[\u4e00-\u9fa5a-zA-Z]{1,20}$/;

const SECONDS = 30;

export default {
  components: {
    ElRow: Row,
    ElCol: Col,
  },
  data() {
    return {
      phone: '',
      code: '',
      studentName: '',
      password: '',
      schoolToken: '',
      schoolName: '',
      loading: false,
      isCountdown: false,
      isRegister: false,
      seconds: 0,
    };
  },
  watch: {
    loading() {
      if (this.loading) {
        this.loadingInstance = Loading.service({
          lock: true,
          text: '请稍后...',
          background: 'rgba(0, 0, 0, 0.7)',
        });
      } else {
        this.loadingInstance.close();
      }
    },
    phone() {
      if (this.phone.length >= 11) {
        this.phone = this.phone.substr(0, 11);
      }
    },
  },
  methods: {
    /* eslint-disable no-alert */
    checkParams() {
      if (!this.code) {
        return '请输入验证码';
      }
      if (!REG_PHONE.test(this.phone)) {
        return '请输入正确的手机号码';
      }
      if (!REG_ST_NAME.test(this.studentName)) {
        return '姓名：1-20位中文或英文字符（1汉字为1字符）';
      }
      if (!REG_PASSWORD.test(this.password)) {
        return '密码：6-20位英文和/或数字';
      }
      return '';
    },
    checkPhone() {
      return REG_PHONE.test(this.phone) ? '' : '请输入正确的手机号码';
    },
    submit() {
      const paramsErr = this.checkParams();
      if (paramsErr) {
        alert(paramsErr);
        return;
      }
      this.loading = true;
      api.register({
        phone: this.phone,
        captcha: this.code,
        name: this.studentName,
        password: this.password,
        schoolToken: this.schoolToken,
      })
        .then(() => {
          this.loading = false;
          this.isRegister = true;
        }, () => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    startCountdown() {
      this.isCountdown = true;
      this.seconds = SECONDS;
      setInterval(() => {
        if (this.seconds <= 0) {
          this.isCountdown = false;
          clearInterval();
          return;
        }
        this.seconds -= 1;
      }, 1000);
    },
    sendCaptcha() {
      if (this.isCountdown) return;
      const phoneErr = this.checkPhone();
      if (phoneErr) {
        alert(phoneErr);
        return;
      }
      this.loading = true;
      api.sendCaptcha({
        phone: this.phone,
        type: 'student_register',
      })
        .then(() => {
          this.startCountdown();
          this.loading = false;
        }, () => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  created() {
    // init schoolToken
    this.schoolToken = this.$route.query.school_token || '';
    this.schoolName = this.$route.query.school_name ? decodeURI(this.$route.query.school_name) : '';
    utils.title(`${this.schoolName}报名页`);
  },
};
</script>

<style lang="scss" scoped>
  .register-container {
    width: 100%;
    text-align: center;
    overflow-y: auto;
    .bg {
      position: fixed;
      z-index: -1;
      width: 100%;
      top: 0;
      bottom: 0;
      background: url(https://img1.wxzxzj.com/vuede46eba4bedf4cb108c2cf0fef30f2429.png) no-repeat;
      background-size: 100% 100%;
    }
    .register-wrap {
      margin-top: 40px;
      .title {
        h1 {
          color: #fff;
        }
        img {
          width: 80%;
        }
      }
      .content {
        min-height: 200px;
        padding: 20px;
        .tip {
          color: #fff;
          line-height: 1.6;
        }
        .card {
          background-color: #fff;
          width: 80%;
          margin: 20px auto 0;
          padding: 20px;
          border-radius: 5px;
          h1 {
            color: #282773;
          }
          p {
            font-size: 16px;
          }
        }
        .input-wrap {
          position: relative;
          height: 50px;
          line-height: 50px;
          margin-top: 20px;
          background-color: #fff;
          border-radius: 5px;
          overflow: hidden;
          .sms-wrap {
            background-color: #eee;
            &.counting {
              background-color: #27d2f2;
              color: #fff;
            }
          }
          input {
            box-sizing: border-box;
            height: 50px;
            width: 100%;
            font-size: 18px;
            border: 0;
            padding: 0 15px;
            &:focus {
              outline: none;
            }
          }
        }
        button {
          height: 50px;
          line-height: 50px;
          width: 200px;
          margin-top: 60px;
          margin-bottom: 20px;
          color: #27d2f2;
          border: 2px solid #27d2f2;
          background-color: #282773;
          border-radius: 5px;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
</style>
